import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private featureFlags: any = null;

  constructor(private http: HttpClient) {}

  async getFeatureFlags(): Promise<void> {
    try {
      const result = await this.getFeatureFlags$().toPromise();
      this.featureFlags = result.data;
    } catch (error) {
      this.featureFlags = null;
    }
  }

  public getFeatureFlags$(): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url_v1}/services/user/ms_client/feature_flags`,
    );
  }

  get(key: string): any {
    return this.featureFlags ? this.featureFlags[key] : null;
  }

  getOrDefault(key: string): any {
    if (key in this.featureFlags) return this.featureFlags[key];
    if ('default' in this.featureFlags) return this.featureFlags['default'];
    return null;
  }

  getByEnv(key: string, subkey: string): any {
    const featureConfig = this.get(key);
    if (!featureConfig) {
      return null;
    }
    const namespace = environment.supplierConfig.clientNameSpace;
    const config = featureConfig[namespace] || featureConfig['default'] || {};
    return config[subkey];
  }

  getAll(): any {
    return this.featureFlags;
  }
}
